import React from 'react'
import { Flex, Heading, Text } from '@homebotapp/hb-react-component-catalog'
import useViewport from '../../../hooks/useViewport'

interface StatBoxProps {
  icon: string
  label: string
  value: string
}

export const StatBox: React.FC<StatBoxProps> = ({ icon, label, value }) => {
  const viewport = useViewport()
  return (
    <Flex
      flexDirection={viewport.isSmall ? 'row' : 'column'}
      justifyContent={viewport.isSmall ? 'space-between' : undefined}
      alignItems='center'
      textAlign='center'
    >
      <Heading variant='eyebrow' size='2xs' color='neutral.900' mb={viewport.isSmall ? 0 : 1}>
        {icon} {label}
      </Heading>
      <Text fontWeight='bold' color='neutral.900' size={viewport.isSmall ? 'sm' : 'md'} m={viewport.isSmall ? 0 : 1}>
        {value}
      </Text>
    </Flex>
  )
}
